import MUISnackbar, { SnackbarProps as MUISnackbarProps } from '@mui/material/Snackbar';
import { styled } from '../styles';

type SnackbarPropType = 'default' | 'success' | 'info' | 'error';

export interface Props
  extends Pick<MUISnackbarProps, 'children' | 'onClose' | 'action' | 'message'> {
  isOpen: boolean;
  type?: SnackbarPropType;
}

const SnackbarStyled = styled(MUISnackbar, {
  shouldForwardProp: (prop) => !['type'].includes(prop as string),
})<{ type: SnackbarPropType }>(({ theme: { palette }, type }) => ({
  '.MuiSnackbarContent-root': {
    minWidth: '44px',
    maxWidth: '720px',
    /* istanbul ignore next */
    backgroundColor: {
      success: palette.notification.valid.main,
      info: palette.notification.info.main,
      error: palette.notification.error.main,
      default: palette.notification.neutral.main,
    }[type],
  },
}));

const Snackbar = ({ isOpen, type = 'default', ...otherProps }: Props) => (
  <SnackbarStyled
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    open={isOpen}
    autoHideDuration={7000}
    type={type}
    {...otherProps}
  />
);

export default Snackbar;
